import { render } from "./SampleCollectionProcess.vue?vue&type=template&id=69700720&scoped=true"
import script from "./SampleCollectionProcess.vue?vue&type=script&lang=js"
export * from "./SampleCollectionProcess.vue?vue&type=script&lang=js"

import "./SampleCollectionProcess.vue?vue&type=style&index=0&id=69700720&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69700720"]])

export default __exports__